import React from "react";

const alertStyle = {
  // backgroundColor: 'white',
  // color: '#4e4e4e',
  // border: '1px solid #4e4e4e',
  padding: '10px',
  // borderRadius: '3px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  // boxShadow: '0px 2px 2px 2px rgba(0, 0, 0, 0.03)',
  width: '300px',
  boxSizing: 'border-box',
  fontSize: '14px'
};

const _mapTypeToClass = (type) => {
  let _cls = type.toLowerCase();
  if (type === "error") {
    _cls = "danger";
  }
  return `alert alert-${_cls} alert-dismissable fade show`
};

const AlertTemplate = ({style, options, message, close}) => (
  <div style={{...alertStyle, ...style}} className={_mapTypeToClass(options.type)}>
    {message}
    <button type={"button"} className={"close"} onClick={close}>
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
);

// const AlertTemplate = ({style, options, message, close}) => (
//   <div style={{...alertStyle, ...style}} className={"alert alert-danger alert-dismissable fade show"}>
//     {/*<span style={{padding: '0'}}>*/}
//     {/*  {options.type === "info" && <FontAwesomeIcon color={"blue"} icon={faInfoCircle}/>}*/}
//     {/*  {options.type === "success" && <FontAwesomeIcon color={"green"} icon={faCheckCircle}/>}*/}
//     {/*  {options.type === "error" && <FontAwesomeIcon size={"lg"} color={"red"} icon={faExclamationCircle}/>}*/}
//     {/*</span>*/}
//     <span>{message}</span>
//     <button type={"button"} className={"close"} onClick={close} style={buttonStyle}>
//       {/*<FontAwesomeIcon size={"sm"} icon={faTimesCircle}/>*/}
//       <span aria-hidden="true">&times;</span>
//     </button>
//   </div>
// );


export default AlertTemplate;
